/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-02-04 14:12:59
 */

import * as request from '@/utils/request'

export default {
  /**
   * getIndividualList
   * @description 人才签约列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getIndividualList(data) {
    return request.get('/individual/list', data)
  },
  /**
   * 保存人才签约
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveIndividual(data) {
    return request.post('/individual/store', data)
  },
  /**
   * getCategoryInfo
   * @description 获取人才签约详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getIndividualInfo(id) {
    let data = {id:id}
    return request.post(`/individual/get_info`, data)
  },
  /**
   * deleteCustomer
   * @description 删除人才签约
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteIndividual(id) {
    let data = {id:id}
    return request.deleteById(`/individual/delete`, data)
  },
  /**
   * @description 获取二维码图片
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  createIndividualQrcode(data) {
    console.log("data", data)
    return request.post('/individual/create_qrcode', data)
  },
}